import { i18n } from '@lingui/core';
import { en, de } from 'make-plural/plurals';

export const UK_LOCALE = 'en-GB';
export const DE_LOCALE = 'de';

i18n.loadLocaleData({
  [UK_LOCALE]: { plurals: en },
  [DE_LOCALE]: { plurals: de },
});
